import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import adyantamLogo from "../assets/adyantam-logo.png";

export default function ResetPasswordScreen() {
  const { resetPassword } = useAuth();

  const [token, setToken]         = useState("");
  const [password, setPassword]   = useState("");
  const [confirm, setConfirm]     = useState("");
  const [showPass, setShowPass]   = useState(false);
  const [error, setError]         = useState("");
  const [loading, setLoading]     = useState(false);
  const [success, setSuccess]     = useState(false);
  const [invalidLink, setInvalidLink] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get("token");
    if (!t) {
      setInvalidLink(true);
    } else {
      setToken(t);
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (password.length < 4) {
      setError("Password must be at least 4 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    const result = await resetPassword(token, password);
    setLoading(false);

    if (!result.success) {
      setError(result.error);
      return;
    }

    setSuccess(true);
  }

  function goToLogin() {
    window.location.href = "/";
  }

  return (
    <div style={styles.page}>

      {/* ── Adyantam Brand Header ── */}
      <div style={styles.brandHeader}>
        <img src={adyantamLogo} alt="Adyantam" style={styles.brandLogo} />
        <div style={styles.brandName}>Adyantam Building Circle®</div>
        <div style={styles.brandTagline}>Empowering Resident Communities</div>
      </div>

      {/* ── Card ── */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>Reset Password</div>

        {invalidLink ? (
          <div>
            <div style={styles.errorTextBlock}>
              ⚠ This link is invalid or incomplete. Please request a new
              password reset link from the Login screen.
            </div>
            <button type="button" style={styles.btn} onClick={goToLogin}>
              Back to Sign In
            </button>
          </div>
        ) : success ? (
          <div>
            <div style={styles.successText}>
              ✅ Your password has been reset successfully. You can now sign
              in with your new password.
            </div>
            <button type="button" style={styles.btn} onClick={goToLogin}>
              Back to Sign In
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div style={styles.field}>
              <label style={styles.label}>New Password</label>
              <div style={styles.passWrap}>
                <input
                  type={showPass ? "text" : "password"}
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => { setError(""); setPassword(e.target.value); }}
                  style={{ ...styles.input, paddingRight: "44px" }}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  style={styles.eyeBtn}
                  onClick={() => setShowPass((v) => !v)}
                  tabIndex={-1}
                >
                  {showPass ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Confirm New Password</label>
              <input
                type={showPass ? "text" : "password"}
                placeholder="Re-enter new password"
                value={confirm}
                onChange={(e) => { setError(""); setConfirm(e.target.value); }}
                style={styles.input}
                autoComplete="new-password"
              />
            </div>

            <div style={styles.errorBox}>
              {error && <span style={styles.errorText}>⚠ {error}</span>}
            </div>

            <button
              type="submit"
              style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
              disabled={loading}
            >
              {loading ? "Resetting…" : "Reset Password"}
            </button>

            <div style={styles.hint}>
              <span style={styles.linkText} onClick={goToLogin}>
                ← Back to Sign In
              </span>
            </div>
          </form>
        )}
      </div>

      <div style={styles.version}>
        <div style={{ fontWeight: "600", color: "#8888a8", marginBottom: "3px" }}>Adyantam Building Circle® · Empowering Resident Communities</div>
        <div>© {new Date().getFullYear()} Adyantam. All rights reserved. · v1.0.0</div>
        <div style={{ marginTop: "3px", fontStyle: "italic" }}>you don't need to know code to build — Conceptualised by Dr. Vijay DSK, powered by AI</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#0f0f13",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    fontFamily: "'Segoe UI', Arial, sans-serif",
  },
  brandHeader: {
    textAlign: "center",
    marginBottom: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  brandLogo: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: "8px",
    border: "2px solid #6c63ff40",
  },
  brandName: {
    fontSize: "26px",
    fontWeight: "700",
    color: "#6c63ff",
    letterSpacing: "3px",
  },
  brandTagline: {
    fontSize: "11px",
    color: "#555570",
    marginTop: "2px",
    letterSpacing: "0.5px",
  },
  card: {
    background: "#1a1a24",
    border: "1px solid #2e2e40",
    borderRadius: "16px",
    padding: "28px 24px",
    width: "100%",
    maxWidth: "360px",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#e8e8f0",
    marginBottom: "20px",
  },
  field: {
    marginBottom: "16px",
  },
  label: {
    display: "block",
    fontSize: "12px",
    color: "#8888a8",
    marginBottom: "6px",
  },
  input: {
    width: "100%",
    background: "#0f0f13",
    border: "1px solid #2e2e40",
    borderRadius: "10px",
    padding: "12px 14px",
    color: "#e8e8f0",
    fontSize: "15px",
    outline: "none",
    boxSizing: "border-box",
  },
  passWrap: {
    position: "relative",
  },
  eyeBtn: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    padding: "0",
    lineHeight: 1,
  },
  errorBox: {
    minHeight: "20px",
    marginBottom: "12px",
  },
  errorText: {
    fontSize: "13px",
    color: "#ff5252",
  },
  errorTextBlock: {
    fontSize: "13px",
    color: "#ff5252",
    lineHeight: "1.6",
    textAlign: "center",
    marginBottom: "16px",
  },
  successText: {
    fontSize: "13px",
    color: "#8888a8",
    lineHeight: "1.6",
    textAlign: "center",
    marginBottom: "16px",
  },
  btn: {
    width: "100%",
    background: "#6c63ff",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "13px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "opacity 0.2s",
  },
  hint: {
    textAlign: "center",
    fontSize: "12px",
    color: "#555570",
    marginTop: "16px",
  },
  linkText: {
    color: "#6c63ff",
    cursor: "pointer",
    textDecoration: "underline",
  },
  version: {
    marginTop: "24px",
    fontSize: "10px",
    color: "#6666a0",
    textAlign: "center",
    lineHeight: "1.7",
    maxWidth: "360px",
  },
};
